import cn from "classnames";
import TextInput from "../../../components/TextInput";
import styles from "./ProfileInformation.module.sass";
import React, { useEffect, useState } from "react";
import { UseApi } from "../../../hooks/use-api";
import { ToastEmitter } from "../../../Services/assets/toast-emitter";
import { GetBrand, UpdateBrand } from "../../../Services/lib/brand";
import Loader from "../../../components/Loader";
import ImageInput from "../../../components/ImageInput";
import { useUser } from "../../../context";
import Card from "../../../components/Card";
import Location from "./location";
import settings from "../../../i11/Settings";
import Dropdown from "../../../components/Dropdown";
import Switch from "../../../components/Switch";

const FiatList = ["USD", "GBP", "HKD"];

const ProfileInformation = ({ className }) => {
	const [taxId, setTaxId] = useState("");
	const [primaryRoyaltyPercent, setPrimaryRoyaltyPercent] = useState("");
	const [stripeProcessingFee, setStripeProcessingFee] = useState("");
	const [secondaryFeePercent, setSecondaryFeePercent] = useState("");
	const [{ data, isLoading }, fetchBrand] = UseApi({
		service: GetBrand,
	});
	const {
		locale,
		setbrand,
		tokens: { group },
	} = useUser();
	const [{ isLoading: brandUpdateIsLoading }, updateBrand] = UseApi({
		service: UpdateBrand,
		successMsg: "Edited Successfull",
	});

	const [image, setImage] = useState("");
	const [image1, setImage1] = useState("");
	const [address, setAddress] = useState({
		AddressLine: "",
		City: "",
		CountryCode: "",
		PostalCode: "",
		StateProvinceCode: "",
	});
	const [siteTitle, setSiteTitle] = useState("");
	const [phone, setPhone] = useState("");
	const [brandName, setBrandName] = useState("");
	const [domain, setDomain] = useState("");
	const [royaltyPercent, setRoyaltyPercent] = useState("");
	const [fiat, setFiat] = useState(FiatList[0]);
	const [primary, setPrimary] = useState(false);
	const [secondary, setSecondary] = useState(false);
	const [kycGifting, setKYCGifting] = useState(false);

	const isAdmin = group === "admin";
	useEffect(() => {
		const fn = async () => {
			const res = await fetchBrand();
			if (res) {
				setPrimary(res?.controller?.kyc_primary_purchase);
				setFiat(res?.defaultCurrency || FiatList[0]);
				setSecondary(res?.controller?.kyc_secondary_purchase || false);
				setKYCGifting(
					res?.controller?.kyc_primary_gift_reciever || false
				);
			}
		};
		fn();
	}, []);

	const handleOnSubmit = async (e) => {
		e.preventDefault();
		if (!data) {
			ToastEmitter({
				msg: "Your brand is not created",
				type: "warning",
			});
			return;
		}
		if (imgL || imgL1) {
			ToastEmitter({
				msg: "Wait untill image upload done.",
				type: "info",
			});
			return;
		}
		let body = {};
		body = {
			_id: data._id,
			siteTitle: siteTitle ? siteTitle : data.siteTitle,
			address: address ? address : data.address,
			brandname: brandName ? brandName : data.brandname,
			description: data.description,
			domain: domain ? domain : data.domain,
			taxId: taxId ? taxId : data.taxId,
			phoneNumber: phone ? phone : data.phoneNumber,
			google_analytics_id: data.googleAnalytics,
			royalty_percent: royaltyPercent
				? royaltyPercent
				: data.royaltyPercent,
		};
		if (isAdmin) {
			body["meterium_primary_royalty_percent"] =
				primaryRoyaltyPercent || data.meterium_primary_royalty_percent;
			body["meterium_secondary_fee_percent"] =
				secondaryFeePercent || data.meterium_secondary_fee_percent;
			body["stripe_processing_fee"] =
				stripeProcessingFee || data.stripe_processing_fee;
			body["defaultCurrency"] = fiat;
			body["controller"] = {
				...data.controller,
				kyc_primary_purchase: primary,
				kyc_secondary_purchase: secondary,
				kyc_primary_gift_reciever: kycGifting,
			};
		}
		if (image.image_list) {
			body["image"] = image.core_image_url;
			body["image_list"] = image.image_list;
		}
		if (image1.image_list) {
			body["image2"] = image1.core_image_url;
			body["image_list2"] = image1.image_list;
		}
		const up = await updateBrand(body);
		if (up) {
			setbrand(body);
		}
	};

	useEffect(() => {
		if (data) {
			setImage(data.image);
			setImage1(data.image2);
			setAddress(data.address);
		}
	}, [data]);

	const HandleChange = (e) => {
		setImage(e);
	};
	const HandleChange1 = (e) => {
		setImage1(e);
	};

	const [imgL, setL] = useState(false);
	const [imgL1, setL1] = useState(false);

	return (
		<Card
			className={cn(styles.card, className)}
			title={settings[locale].brand_info}
			classTitle="title-green"
		>
			{isLoading || !data ? (
				<div className={styles.loaderWrap}>
					<Loader />
				</div>
			) : (
				<form className={styles.form_} onSubmit={handleOnSubmit}>
					<div className={styles.profile}>
						<ImageInput
							where="BRANDS"
							callBack={HandleChange}
							initial={data.image}
							className={styles.field}
							label={settings[locale].image}
							required
							tooltip="Image"
							setL={setL}
						/>
						<ImageInput
							where="BRANDS"
							callBack={HandleChange1}
							initial={data.image2}
							className={styles.field}
							label={settings[locale].logo}
							required
							tooltip="Image"
							setL={setL1}
						/>
						<div className={styles.fieldset}>
							<TextInput
								className={styles.field}
								label={settings[locale].brand_name}
								name="brand-name"
								type="text"
								tooltip="Brand name"
								required
								defaultValue={data ? data.brandname ?? "" : ""}
								onChangeInput={setBrandName}
							/>
							<TextInput
								className={styles.field}
								label={settings[locale].brand_domain}
								name="brand-domain"
								type="text"
								tooltip="Brand domain"
								required
								defaultValue={data ? data.domain ?? "" : ""}
								onChangeInput={setDomain}
							/>

							<TextInput
								className={styles.field}
								label={settings[locale].site_title}
								name="site title"
								type="text"
								tooltip="Marketplace web site title"
								required
								defaultValue={data ? data.siteTitle ?? "" : ""}
								onChangeInput={setSiteTitle}
							/>

							<TextInput
								className={styles.field}
								label={settings[locale].tax_id}
								name="tax-id"
								tooltip="Tax identification number"
								defaultValue={data ? data.taxId ?? "" : ""}
								onChangeInput={setTaxId}
							/>
							<TextInput
								className={styles.field}
								label={settings[locale].phone_number}
								name="phone-number"
								tooltip="Phone number"
								defaultValue={
									data ? data.phoneNumber ?? "" : ""
								}
								onChangeInput={setPhone}
							/>
							<Location data={data} setAddress={setAddress} />
							{isAdmin && (
								<div>
									<Dropdown
										label={settings[locale].fiat}
										value={fiat}
										options={FiatList}
										setValue={(v) => {
											setFiat(v);
										}}
									/>
									<div className={styles.switch}>
										<p>
											{
												settings[locale]
													.kyc_primary__purchase
											}
										</p>
										<Switch
											value={primary}
											onChange={(v) => {
												setPrimary(!primary);
											}}
										/>
									</div>
									<div className={styles.switch}>
										<p>
											{
												settings[locale]
													.kyc_secondary_purchase
											}
										</p>
										<Switch
											value={secondary}
											onChange={(v) => {
												setSecondary(!secondary);
											}}
										/>
									</div>
									<div className={styles.switch}>
										<p>{settings[locale].kyc_gifting}</p>
										<Switch
											value={kycGifting}
											onChange={(v) => {
												setKYCGifting(!kycGifting);
											}}
										/>
									</div>
								</div>
							)}
							<TextInput
								disabled={!isAdmin}
								style={{ color: !isAdmin && "grey" }}
								className={styles.field}
								defaultValue={data.stripe_processing_fee}
								step="any"
								label={settings[locale].stripe_processing_fee}
								name="primary_royalty_percent"
								type="number"
								min="0"
								max="100"
								currency="%"
								onChangeInput={setStripeProcessingFee}
								required
							/>
							<TextInput
								disabled={!isAdmin}
								style={{ color: !isAdmin && "grey" }}
								step="any"
								className={styles.field}
								defaultValue={
									data.meterium_primary_royalty_percent
								}
								label={settings[locale].primary_royalty_percent}
								name="primary_royalty_percent"
								type="number"
								min="0"
								currency="%"
								onChangeInput={setPrimaryRoyaltyPercent}
								max="100"
								required
							/>
							<TextInput
								disabled={!isAdmin}
								style={{ color: !isAdmin && "grey" }}
								step="any"
								label={settings[locale].royalty_percent}
								name="royalty-percent"
								type="number"
								currency="%"
								defaultValue={data.royalty_percent}
								onChangeInput={setRoyaltyPercent}
								max="100"
								required
							/>
							<TextInput
								disabled={!isAdmin}
								style={{ color: !isAdmin && "grey" }}
								step="any"
								className={styles.field_sec}
								defaultValue={
									data.meterium_secondary_fee_percent
								}
								label={settings[locale].secondary_fee_percent}
								name="secondary_fee_percent"
								required
								type="number"
								min="0"
								max="100"
								currency="%"
								onChangeInput={setSecondaryFeePercent}
							/>

							<button
								className={cn("button", styles.button, {
									disabled: brandUpdateIsLoading,
								})}
								type="submit"
							>
								{brandUpdateIsLoading ? (
									<Loader white />
								) : (
									<span>{settings[locale].save}</span>
								)}
							</button>
						</div>
					</div>
				</form>
			)}
		</Card>
	);
};

export default ProfileInformation;
